import type { Character } from '@/types';
import { getModifier } from '@/types';

export const STAT_NAMES: Record<string, string> = {
  STR: 'СИЛ',
  DEX: 'ЛОВ',
  CON: 'ТЕЛ',
  INT: 'ИНТ',
  WIS: 'МДР',
  CHA: 'ХАР',
};

export const STAT_FULL_NAMES: Record<string, string> = {
  STR: 'Сила',
  DEX: 'Ловкость',
  CON: 'Телосложение',
  INT: 'Интеллект',
  WIS: 'Мудрость',
  CHA: 'Харизма',
};

export function getStatModifier(character: Character, stat: string): number {
  const statMap: Record<string, number> = {
    STR: character.strength,
    DEX: character.dexterity,
    CON: character.constitution,
    INT: character.intelligence,
    WIS: character.wisdom,
    CHA: character.charisma,
  };
  return getModifier(statMap[stat] || 10);
}

export function rollDice(count: number, sides: number): number[] {
  return Array.from({ length: count }, () =>
    Math.floor(Math.random() * sides) + 1
  );
}

export function evaluateResult(total: number): { text: string; color: string; type: 'miss' | 'partial' | 'success' } {
  if (total <= 6) return { text: 'Провал!', color: 'text-red-400', type: 'miss' };
  if (total <= 9) return { text: 'Частичный успех!', color: 'text-yellow-400', type: 'partial' };
  return { text: 'Полный успех!', color: 'text-green-400', type: 'success' };
}

export interface RollRequest {
  dice: string;
  count: number;
  sides: number;
  stat?: string;
  moveName: string;
}

export function parseRollRequest(text: string): RollRequest | null {
  const match = text.match(/\[ROLL:(\d+)d(\d+)(?:\+(\w+))?:([^\]]+)\]/);
  if (!match) return null;
  return {
    dice: `${match[1]}d${match[2]}`,
    count: parseInt(match[1], 10),
    sides: parseInt(match[2], 10),
    stat: match[3],
    moveName: match[4],
  };
}

export function removeRollMarkers(text: string): string {
  return text.replace(/\[ROLL:[^\]]+\]/g, '').trim();
}

export function formatRollResult(
  moveName: string,
  rolls: number[],
  modifier: number,
  statName: string | null
): string {
  const diceSum = rolls.reduce((a, b) => a + b, 0);
  const total = diceSum + modifier;
  const result = evaluateResult(total);

  const rollsStr = rolls.join(' + ');
  const modStr = modifier >= 0 ? `+${modifier}` : `${modifier}`;
  const statStr = statName ? `${statName}(${modStr})` : modStr;

  return `[Бросок: ${moveName}] 🎲 ${rollsStr} ${statName ? `+ ${statStr}` : ''} = ${total} — ${result.text}`;
}
